import React, { useState, useEffect, useRef } from "react";
import EncounterCard from "./common/EncounterCard";
import SearchBox from "./common/SearchBox";
import { getUnsignedWorkerEncounters } from "../components/services/soar";
import BackIcon from "./common/BackIcon";

function UnsignedEncounters(props) {
  const [encounters, setEncounters] = useState([]);
  const isMountedRef = useRef(true);
  const [searchQuery, setSearchQuery] = useState("");
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  useEffect(() => {
    if (safyInfo) {
      getUnsignedWorkerEncounters(
        safyInfo.user.safyInfo.SOARUserId,
        safyInfo.user.safyInfo.BusinessUnitIdName
      ).then((response) => {
        if (response && isMountedRef.current) {
          setEncounters(
            JSON.parse(response).resultset.result.filter(
              (enc) => enc.ccx_draftsigned["@name"] === "No"
            )
          );
        }
      });
    }

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleSearch = ({ currentTarget: input }) => {
    setSearchQuery(input.value);
  };

  return (
    <>
      <BackIcon></BackIcon>
      <h1>{safyInfo.user.displayName}</h1>
      <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 mb-4">
        <div className="col pt-3">
          <SearchBox
            value={searchQuery}
            placeholder="Search Client Name"
            onChange={handleSearch}
            clearSearch={() => setSearchQuery("")}
          />
        </div>
      </div>
      <span>
        <span className="h5 bg-danger px-2 text-white rounded mx-2">
          {
            encounters.filter((e) =>
              e.ccx_patient["@name"]
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
            ).length
          }
        </span>
        Unsigned Encounters
      </span>
      {encounters
        .filter((e) =>
          e.ccx_patient["@name"]
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
        )
        .map((encounter) => (
          <div className="p-2" key={`tl-${encounter.ccx_encounterid}`}>
            <EncounterCard encounter={encounter} />
          </div>
        ))}
    </>
  );
}

export default UnsignedEncounters;
